import { useState } from "react";

import Button from 'react-bootstrap/Button';
import ReactModal from 'react-modal';

ReactModal.setAppElement('*');

export const ModalChoosePlayerName = ({ ynmOpen, ynmQuestionText, ynmNoText, ynmYesText, ynmNoFunction, ynmYesFunction, list }) => {

	var j = 0;
	
	const [pickedPlayerName, setPickedPlayerName] = useState('');
	const [enteredPlayerName, setEnteredPlayerName] = useState('');

	const grabPlayerNameSelect = (event) => {
		setPickedPlayerName(event.target.value);
	};

	const grabPlayerNameInput = (event) => {
		setEnteredPlayerName(event.target.value);
	};
	
	const resolveInputs = () => {
		//alert(pickedPlayerName)
		//alert(enteredPlayerName)
		if (pickedPlayerName !== '') {
			//alert('picked')
			return pickedPlayerName;
		}
		if (enteredPlayerName !== '') {
			//alert('entered')
			return enteredPlayerName;
		}
		return undefined;
	};

	return (
		<div>
			<ReactModal isOpen={ynmOpen} appElement={document.getElementById('app')}
				style={{
					overlay: {
						position: 'fixed',
						zIndex: 1020,
						top: 0,
						left: 0,
						width: '100vw',
						height: '100vh',
						background: 'rgba(128, 255, 255, 0.75)',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					},
					content: {
						background: 'white',
						width: '45rem',
						maxWidth: 'calc(100vw - 2rem)',
						maxHeight: 'calc(100vh - 2rem)',
						overflowY: 'auto',
						position: 'relative',
						border: '1px solid #ccc',
						borderRadius: '0.3rem',
					}
				}}
			>
				{ynmQuestionText}<br />
				<br />
				to EXISTING Player:&nbsp;
				<select value={pickedPlayerName} onChange={grabPlayerNameSelect}>
					<option value={''}>None</option>
					{list.map(p => (
						<option key={j++} value={p['personRealname']}>{p['personRealname']}</option>
					))}
				</select>
				<br />
				<br />
				-- OR --<br />
				<br />
				NEW Player: <input type="text" value={enteredPlayerName} placeholder='Player Name' size='20' onChange={grabPlayerNameInput} />
				<br />
				<br />
				<Button variant="primary" onClick={() => ynmYesFunction(resolveInputs())}>{ynmYesText}</Button>&nbsp;&nbsp;&nbsp;
				<Button variant="secondary" onClick={ynmNoFunction}>{ynmNoText}</Button>
			</ReactModal>
		</div>
	);

};
